import api from "./api";
import currentUserId from "../reduxSaga/sagas/requests/currentUserId";

// Subscription contracts of the client companies, served by profile-erp (/clientContract).
class ClientContractService {
  add(contract) {
    return api.post("/clientContract/addContract/" + currentUserId(), contract);
  }
  getBySociete(idSociete) {
    return api.get("/clientContract/getContractsBySociete/" + idSociete);
  }
  // latest contract of every client of the connected user's partner
  getSummary() {
    return api.get("/clientContract/getContractsSummary/" + currentUserId());
  }
}

export default new ClientContractService();
